module.exports = "/work-site/img/mdms.a5497b60.png";